import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BaseWinnerListComponent from '@/components/game/implementations/_base/_components/winner-list';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';

@Component({
  name: 'WinnerListComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class WinnerListComponent extends BaseWinnerListComponent {
  private mounted() {
    const game = this.gameController.getGame();
    this.updateWinnerListVisibility(game.state);

    Vue.nextTick(() => {
      this.gameController
          .onGameStateChanged(this.handleGameStateChanged)
          .onGameWon(this.handleGameWon);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/winner-list/winner-list.component.ts